import React, { PureComponent } from 'react';
import { PropTypes } from 'prop-types';
import styled from 'styled-components';
import Sifter from 'sifter';
import { debounce, isEqual } from 'lodash';
import { injectIntl } from 'react-intl';
import { format } from '@origo_vl_banking/utils';
import { TextInput } from '../';

const SearchInputContainer = styled.div`
  width: 250px;
`;

class Search extends PureComponent {
  state = {
    searchTerm: null,
  };

  componentDidUpdate(prevProps) {
    if (!isEqual(this.props.data, prevProps.data)) {
      this.search();
    }
  }

  onChange = (e) => {
    if (e.target.value) {
      this.setState({ searchTerm: e.target.value }, this.search);
    } else {
      this.setState({ searchTerm: null }, this.search);
    }
  };

  search = debounce(() => {
    const {
      data,
      columns,
      onSearch,
      idField,
      nestedField,
      nestedSearch,
      searchConjunction,
    } = this.props;
    const { searchTerm } = this.state;

    if (!searchTerm) {
      return onSearch(data);
    }
    const formattedData = this.formatData(data);
    const fields = data[0] ? Object.keys(data[0]) : columns;
    let nestedFields = [];

    if (fields.includes(nestedField) && nestedSearch) {
      nestedFields = data[0] ? Object.keys(data[0][nestedField]) : '';

      nestedFields = nestedFields.map(e => `${nestedField}.${e}`);
      fields.push(...nestedFields);
    }

    if (fields.includes(idField)) {
      fields.splice(fields.indexOf(idField), 1);
    }

    const sifter = new Sifter(formattedData);
    const result = sifter.search(searchTerm, {
      fields,
      nesting: nestedSearch,
      conjunction: searchConjunction,
    });

    const filteredData = result.items.map(item => data[item.id]);
    return onSearch(filteredData);
  }, 300);

  formatData = (data) => {
    const formattedData = [];
    data.forEach((item) => {
      const formattedItem = {};
      Object.entries(item).forEach(([key, value]) => {
        formattedItem[key] = format.value(value);
      }, this);
      formattedData.push(formattedItem);
    }, this);
    return formattedData;
  };

  render() {
    const {
      name,
      intl,
      formattedPlaceholder,
      height,
    } = this.props;

    const placeholder = formattedPlaceholder
      ? intl.formatMessage({ id: this.props.placeholder })
      : this.props.placeholder;

    return (
      <SearchInputContainer>
        <TextInput
          placeholder={placeholder}
          onChange={this.onChange}
          name={name}
          height={height}
        />
      </SearchInputContainer>
    );
  }
}

Search.propTypes = {
  columns: PropTypes.array.isRequired,
  data: PropTypes.array.isRequired,
  onSearch: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  name: PropTypes.string.isRequired,
  formattedPlaceholder: PropTypes.bool,
  idField: PropTypes.string.isRequired,
  nestedField: PropTypes.string,
  nestedSearch: PropTypes.bool,
  searchConjunction: PropTypes.string,
  height: PropTypes.string,
};

Search.defaultProps = {
  placeholder: null,
  nestedField: 'Details',
  nestedSearch: false,
  searchConjunction: 'or',
  formattedPlaceholder: false,
  height: null,
};

export default injectIntl(Search);
